export default "__VITE_ASSET__DYNcpQWw__"